import React, { ReactElement } from 'react';
import { useRouter } from 'next/router'; // Import useRouter
import LeadFormWithZipFill from '@/components/LeadForm/LeadFormWithZipFill';
import Link from 'next/link';
import BlueOnWhiteLogo from '@/components/Logo/BlueOnWhiteLogo';
import SlimFooter from '@/components/Footer/SlimFooter';
import FeaturedOn from '@/components/FeatureSection/FeaturedOn';
import LeadFormReviewBadge from '@/components/ReviewBadge/LeadFormReviewBadge';
import MetaTags from '@/components/Head/MetaTags';

export default function Page() {
  const router = useRouter();
  let zip = '';
  let cid = '';

  // Ensure zip is a string, even if the URL parameter is an array
  if (Array.isArray(router.query.zip)) {
    zip = router.query.zip[0];
  } else if (router.query.zip) {
    zip = router.query.zip;
  }

  if (Array.isArray(router.query.cid)) {
    cid = router.query.cid[0];
  } else if (router.query.cid) {
    cid = router.query.cid;
  }

  // Check if the screen width is less than a certain threshold (e.g., 768px for mobile)
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  return (
    <div>
      <MetaTags title="Get Started with EnergyPal" />
      <header className="bg-transparent inset-x-0 top-0 z-10">
        <div className="flex items-center justify-center px-4 py-5 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div>
            <Link href="/" className="flex">
              <span className="sr-only">EnergyPal</span>
              <BlueOnWhiteLogo className="w-auto h-12" />
            </Link>
            <LeadFormReviewBadge />
          </div>
        </div>
      </header>
      <main
        className={`flex flex-col items-center w-full pt-20 pb-20 ${
          isMobile ? '' : 'animate-slide-in'
        }`}
      >
        <div className="w-full max-w-3xl px-4 py-4 mb-6 md:px-6 lg:px-8">
          <LeadFormWithZipFill zip={zip} cid={cid} />
        </div>
        <div className="w-full max-w-screen px-4 py-4 md:px-6 lg:px-8">
          <FeaturedOn noBg />
        </div>
      </main>
      <SlimFooter />
      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          .animate-slide-in {
            animation: slideIn 0.75s ease-out forwards;
          }
        `}
      </style>
    </div>
  );
}

Page.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};
